<template>
    <div class="doc-section">
        <h1>Habilitar / Deshabilitar Dispositivo</h1>
        <p>
            Esta funcionalidad permite dar de baja un dispositivo del sistema. Para realizar esta acción, localice la
            columna
            <strong>Acciones</strong> en la lista de dispositivos.
        </p>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <h2>Procedimiento de Eliminación</h2>
        <ul class="ul-contenedor step-list">
            <li>Haga clic en switch<strong>Habilitar/Dehabilitar</strong> correspondiente al equipo deseado.
            </li>
            <li>Se mostrará un mensaje emergente de confirmación para evitar eliminaciones accidentales.</li>
        </ul>


        <h2>Opciones de Confirmación</h2>
        <ul class="ul-contenedor step-list">
            <li><strong>Botón Cancelar:</strong> Cierra la ventana y el dispositivo permanece intacto.</li>
            <li><strong>Botón Aceptar:</strong> Procesa la baja. Al finalizar, recibirá una
                notificación de éxito o de error según el resultado.</li>
        </ul>

        <div class="card" style="border-left-color: #e53e3e;">
            <h3>Restricción: Usuarios Asignados</h3>
            <p>
                Si el dispositivo tiene <strong>usuarios asignados</strong>, el sistema bloqueará la eliminación para
                proteger la integridad de los datos.
            </p>
            <p>
                <em><strong>Solución:</strong> Debe editar el dispositivo primero, limpiar la lista de usuarios
                    asociados y guardar los cambios. Una vez que la lista esté vacía, podrá eliminar el equipo
                    exitosamente.</em>
            </p>
        </div>


        <h3>Referencia Visual</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesEliminar" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesEliminarMoviles" />
        </div>
    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'EliminarDispositivo',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesEliminar: [
            {
                nombre: "Confirmación eliminar dispositivo",
                url: "img/Dispositivos/confirmacionEliminarDispositivo.png",
                descripcion: "Mensaje de confirmación para eliminar el dispositivo seleccionado."
            },
            {
                nombre: "Error de Eliminación",
                url: "img/Dispositivos/errorEliminarDispositivo.png",
                descripcion: "Notificación de bloqueo por usuarios vinculados al equipo."
            }
        ],
        imagenesEliminarMoviles: [
            {
                nombre: "Confirmación eliminar dispositivo",
                url: "img/Dispositivos/moviles/confirmacionEliminarDispositivo.png",
                descripcion: "Mensaje de confirmación para eliminar el dispositivo seleccionado."
            },
            {
                nombre: "Error de Eliminación",
                url: "img/Dispositivos/errorEliminarDispositivo.png",
                descripcion: "Notificación de bloqueo por usuarios vinculados al equipo."
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>
